import { faBadgeCheck as faBadgeCheckLight } from '@fortawesome/pro-light-svg-icons';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { UserBadgeList } from '~/components/organisms/UserBadgeList';

export type IAppUserBadgesPageProps = {
  appId: string;
};

export const AppUserBadgesPage: React.FC<IAppUserBadgesPageProps> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('AppUserBadgesPage.seo.title')}</title>
      </Helmet>

      <Heading
        icon={<FontAwesomeIcon icon={faBadgeCheckLight} />}
        title={t('AppUserBadgesPage.title')}
        subtitle={t('AppUserBadgesPage.subtitle')}
        actions={
          <Button
            href={`/apps/${appId}/badges/create`}
            icon={<FontAwesomeIcon icon={faPlus} />}
          >
            {t('AppUserBadgesPage.create')}
          </Button>
        }
      />

      <UserBadgeList appId={appId} />
    </>
  );
};
